module.exports = __webpack_public_path__ + "img/judge.bc94e3db.jpeg";